module.exports = __webpack_public_path__ + "img/back-prediction.8c77534d.png";